import React, { useState, useEffect, useContext } from 'react';
import {TextStyle, Layout, Card, Stack, Link, Button, InlineError} from '@shopify/polaris';
import {useReducerRequest} from '@thinkwell/react.common';
import ReactHtmlParser from 'react-html-parser'
import EditCourse from './EditCourse';
import { CourseContext } from '../contexts/Course'
import compact from 'lodash/compact'

const formatDate = (dateStr) => {
  return new Intl.DateTimeFormat('en-US', {
    year: 'numeric',
    month: 'long',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit'
  }).format(new Date(dateStr))
};

export default function Course(props) {
  const [course, setCourse] = useContext(CourseContext);
  const [editing, setEditing] = useState(false)

  const [stateDelete, onDelete] = useReducerRequest('delete', {onSuccess: () => {
    props.onDelete && props.onDelete()
  }})

  const deleteCourse = () => {
    onDelete(`/courses/${course.id}.json`,
      null,
      'Are you sure you want to delete this course? This action is irreversible.'
    )
  }

  return (
    <div className="course">
      <Layout>
        <Layout.Section primary>
        { !editing ?
          (<Card>
            <Card.Header title={course.name}>
              <Button plain onClick={() => props.navigateToRef.current('courses', {withContext: 'url'}) }>Back to Courses</Button>
              <Button plain onClick={() => setEditing(true) }>Edit</Button>
              <Button plain onClick={() => window.open(`/courses/${course.id}/tree`, '_blank') }>Tree</Button>
              <Button plain destructive loading={stateDelete.requesting} onClick={deleteCourse}>Delete</Button>
              {stateDelete.error ? <InlineError message={stateDelete.error} fieldID="deleteUserErrorFieldID" /> : null}
            </Card.Header>
            <Card.Section>
              <table className="table-item"><tbody>
                <tr><th>Product</th><td>{course.product.name}</td></tr>
                { course.player_path ? <tr><th>Video Player Path (Flash)</th><td>{course.player_path}</td></tr> : null }
                { course.mapleta_parent_id ? <tr><th>Maple Parent ID</th><td>{course.mapleta_parent_id}</td></tr> : null }
                { course.stand_alone_video ? <tr><th>Stand alone videos</th><td>Yes</td></tr> : null }
                { course.lock_video_dimensions ? <tr><th>Lock video dimensions</th><td>Yes</td></tr> : null }
                { course.theme ? <tr><th>Theme</th><td>{course.theme}</td></tr> : null }
                { course.changelog ? <tr><th>Changelog</th><td style={{whiteSpace: 'pre-wrap'}}>{course.changelog}</td></tr> : null }
                { course.created_at ? <tr><th>Created at</th><td>{formatDate(course.created_at)}</td></tr> : null }
              </tbody></table>
            </Card.Section>
          </Card>) : null
        }
        { editing ?
          <EditCourse
            active={editing}
            item={course}
            onSave={setCourse}
            onActive={(active) => { if (active != editing) { setEditing(active) } }}
          /> : null
        }
        </Layout.Section>
      </Layout>
    </div>
  );
}
